<template>
  <div class="table_wrap">
    <el-table class="list-table" header-cell-class-name="list-header"
              style="width: 100%;" height="695" empty-text="데이터가 없습니다."
              :data="itemData"
    >
      <el-table-column
          class="table_no"
          type="index"
          label="No"
          width="90"
          class-name="num text-center"
          :index="tableIdx"
      >
      </el-table-column>
      <el-table-column
          label="상태" width="90" class-name="text-center">
        <template slot-scope="scope">
          <span>{{ returnStatus(scope.row.im_status) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="카테고리" width="90" class-name="text-center" prop="ic_name"></el-table-column>
      <el-table-column label="에디션" width="" class-name="text-center" prop="c_title">
        <template slot-scope="scope">
          <span>{{ returnEdition(scope.row.im_edition) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="타입" width="" class-name="text-center">
        <template slot-scope="scope">
          <span>{{ returnItemType(scope.row.i_type) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="제목" width="" class-name="text-center" prop="i_name"></el-table-column>
      <el-table-column label="창작자" width="" class-name="text-center">
        <template slot-scope="scope">
          <span>{{ returnName(scope.row.original_nick) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="소유자" width="" class-name="text-center">
        <template slot-scope="scope">
          <span>{{ returnName(scope.row.provider_nick) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="유틸리티 수" width="" class-name="text-center">
        <template slot-scope="scope">
          <span>{{ scope.row.Utility.cnt}}</span>
        </template>
      </el-table-column>
      <el-table-column label="큐레이터" width="" class-name="text-center">
        <template slot-scope="scope">
          <span>{{ returnName(scope.row.curator_nick) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="컬렉션" width="" class-name="text-center">
        <template slot-scope="scope">
          <span>{{ returnCollection(scope.row) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="등록일시" width="" class-name="text-center" prop="c_end_time">
        <template slot-scope="scope">
                    <span>
                        {{ returnDateFormat(scope.row.created_at, 'YYYY-MM-DD HH:mm') }}
                    </span>
        </template>
      </el-table-column>

      <el-table-column
          label="옵션" width="" class-name="text-center">
        <template slot-scope="scope">
          <div class="row-info ">
            <!--                        <div class="row-info pointer" @click="moveDetail(scope.row.i_idx)">
                                        [상세]
                                    </div>-->
            <el-button class="com_btn" @click="moveDetail(scope.row.i_idx)">
              상세
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import dateMixins from "@/mixins/dateMixins";
import {itemStatus, itemCategory, itemEdition, itemType} from "@/service/itemService";
import util from "@/mixins/util";

export default {
  name: "ItemListDefaultLayout",
  mixins: [dateMixins],
  components: {},
  inject: [],
  provide() {
    return {}
  },
  props: {
    itemData: {
      type: Array,
      default: () => {
        return []
      }
    },
    paginationData: {
      type: Object,
      default: () => {
        return {
          total: 0,
          page: 0,
          size: 0,
        }
      }
    },
  },
  data() {
    return {
      categoryType: itemCategory,
      itemStatus: itemStatus,
      itemEdition: itemEdition,
      itemType: itemType,
    }
  },
  beforeRouterEnter() {
  },
  created() {
  },
  mounted() {

  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {},
  methods: {
    moveDetail(idx) {
      this.$router.push(`/item/list/${idx}`);
    },
    tableIdx(index) {
      return this.paginationData.total - index - (this.paginationData.page - 1) * this.paginationData.size;
    },
    returnStatus(value) {
      let keys = Object.keys(this.itemStatus)
      let key = keys.filter(status => Number(status) === value);
      if (util.isEmpty(key)) {
        return '-'
      }
      return this.itemStatus[key].name

    },
    returnEdition(value) {
      let keys = Object.keys(this.itemEdition)
      let key = keys.filter(edition => Number(edition) === value);
      if (util.isEmpty(key)) {
        return '-'
      }
      return this.itemEdition[key].name
    },
    returnName(name) {
      return !util.isEmpty(name) ? name : '-'
    },
    returnItemType(value) {
      let keys = Object.keys(this.itemType)
      let key = keys.filter(type => type === value);
      if (util.isEmpty(key)) {
        return '-'
      }
      return this.itemType[key].name
    },
    returnCollection(data) {
      if (!util.isEmpty(data.Collection)) {
        return data.Collection.c_title
      }
    }
  },
  watch: {},
}
</script>

<style scoped>

</style>
